export default "__VITE_ASSET__C7HIRZ9B__"